<template>
  <AttrSelect
    label="12H/24H制"
    :value="shape.attrs.sourceHourMode ?? 'system'"
    :options="options"
    :disabled="!!disabled"
    @change="onChange"
  />
</template>
<script lang="ts" setup>
import { Shape } from '@/services/shape';
import { ImageArrayAttribute } from '@/services/shape/attributes/image-array';
import { PropType } from 'vue';

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const options = [
  { label: '跟随固件系统', value: 'system' },
  { label: '24H', value: '24h' },
  { label: '12H', value: '12h' }
];

const onChange = (val: ImageArrayAttribute['sourceHourMode']) => {
  props.shape.setAttrs({ sourceHourMode: val });
};
</script>
